<template>
  <div class="section-progress mx-auto">
    <div class="d-flex">
      <bs-tooltip
        v-for="[sectionKey, section] of sections"
        :key="sectionKey"
        :title="getTitle(section)"
        placement="bottom"
      >
        <SectionRadio
          :chapter-display-order="chapterDisplayOrder"
          :current-section="currentSection"
          :section="section"
        />
      </bs-tooltip>
    </div>
    <div>
      <SummaryButton />
    </div>
  </div>
</template>

<script>
import SectionRadio from '../SectionRadio.vue'
import SummaryButton from '../SummaryButton.vue'

export default {
  components: { SummaryButton, SectionRadio },
  props: {
    currentSection: {
      type: Object,
      required: true,
    },
    sections: {
      type: Map,
      required: true,
    },
    chapterDisplayOrder: {
      type: [String, Number],
      required: true,
    },
  },
  mounted() {
    const node = document.querySelector('.tooltip')
    if (node) {
      node.parentNode.removeChild(node)
    }
  },
  methods: {
    getTitle(section) {
      return `Section ${section.section_number}: ${section.name}`
    },
  },
}
</script>

<style  scoped>
.section-progress {
  display: flex;
  place-items: center;
  justify-content: space-between;
  width: 89%;
}
</style>
